import { useState } from "react";
import { classNames } from "primereact/utils";
import styles from "./DefaultTextareaField.module.scss";
import { Controller, useFormContext } from "react-hook-form";
import { useAppContext } from "../../../../../AppContext";
import { AppTooltip } from "../../../tooltip/AppTooltip";

import { dvSize } from "../../../../infrastructure/utilities/viewportUnitsUtility";
interface IDefaultTextareaFieldProps {
  name: string;
  tooltip?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  rows?: number;
  className?: string;
  disabled?: boolean;
  width?: string;
  minWidth?: string;
}

export const DefaultTextareaField = ({
  name,
  tooltip,
  label,
  placeholder = "",
  required = false,
  rows = 6,
  className,
  disabled,
  width,
  minWidth,
}: IDefaultTextareaFieldProps) => {
  const { control } = useFormContext();
  const { isDesktopOrTablet } = useAppContext();
  const [isFocused, setIsFocused] = useState(false);

  if (!width) {
    width = isDesktopOrTablet ? "600px" : dvSize("80dvw");
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <div
          style={{ width: width, minWidth: minWidth, maxWidth: width }}
          className={classNames(styles.root, className, {
            [styles.root_disabled]: disabled,
          })}
        >
          {label && (
            <div
              className={classNames(styles.root_label, {
                [styles.root_label_interacted_with]: isFocused || !!field.value,
                [styles.root_label_error]: !!fieldState.error?.message,
              })}
            >
              {label}{required ? "*" : ""}
              <AppTooltip content={tooltip} />
            </div>
          )}
          <textarea
            {...field}
            rows={rows}
            placeholder={placeholder}
            disabled={disabled}
            className={styles.root_textarea}
            onFocus={() => setIsFocused(true)}
            onBlur={(e) => {
              setIsFocused(false);
              field.onBlur();
            }}
            value={field.value ?? ""}
          />
          {fieldState.error?.message && (
            <span className={styles.root_error}>{fieldState.error.message}</span>
          )}
        </div>
      )}
    />
  );
};
